import ServicePerson from '../src/ServicePerson';
export default ServicePerson;
